module.exports = __webpack_public_path__ + "media/images/sp/stores/sola/how-to-enjoy-sola-05-bca442410153e434d1359d825891bf22.jpg";